import React from 'react';

import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import * as S from './styles';

import TableRowChildren from './components/TableRowChildren';

export default function TableMinimizable({
  size,
  header,
  data,
  onCallback,
  maxHeight,
}) {
  return (
    <S.Wrapper component={Paper} maxHeight={maxHeight}>
      <Table stickyHeader size={size}>
        <TableHead>
          <TableRow>
            <TableCell />
            {header.map(({ label, align }, index) => (
              <TableCell align={align} key={index}>
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.keys(data).map((d, index) => (
            <TableRowChildren
              key={index}
              header={header}
              data={data[d]}
              detach={d}
              onCallback={onCallback}
            />
          ))}
        </TableBody>
      </Table>
    </S.Wrapper>
  );
}

TableMinimizable.propTypes = {
  size: PropTypes.oneOf(['medium', 'small']),
  header: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['left', 'center', 'right']),
      formatted: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  onCallback: PropTypes.func,
  maxHeight: PropTypes.number,
};

TableMinimizable.defaultProps = {
  size: 'medium',
  onCallback: () => undefined,
  maxHeight: 13,
};
